var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBroadbandInternetFilled = function SvgHtlBroadbandInternetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlBroadbandInternetFilled_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v15.995h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlBroadbandInternetFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.69 14A1.89 1.89 0 0 1 2 11.964v-.929A1.888 1.888 0 0 1 3.69 9H11V4.5a.5.5 0 0 1 1 0V9h.312A1.888 1.888 0 0 1 14 11.035v.929A1.889 1.889 0 0 1 12.31 14H3.69Zm.425-6.348a5.462 5.462 0 0 1-.616-2.689 5.472 5.472 0 0 1 .616-2.69.5.5 0 0 1 .888.46 4.468 4.468 0 0 0-.5 2.248 4.47 4.47 0 0 0 .5 2.211.5.5 0 1 1-.888.457v.003Zm1.947-.6a4.07 4.07 0 0 1-.508-2.089 4.07 4.07 0 0 1 .508-2.089.5.5 0 1 1 .879.479 3.061 3.061 0 0 0-.384 1.589v.038a3.061 3.061 0 0 0 .384 1.589.5.5 0 0 1-.88.48v.003Zm1.983-.514A2.746 2.746 0 0 1 7.6 4.964a2.752 2.752 0 0 1 .442-1.575.5.5 0 0 1 .841.54A1.757 1.757 0 0 0 8.6 4.946v.037c-.011.36.089.714.286 1.015a.5.5 0 1 1-.842.537v.003Z"
  }))));
};
export default SvgHtlBroadbandInternetFilled;